import APICall from "../utils/APICall";

export default class AccountOfficerServices {
  static listAccountOfficer = async (
    page,
    pageLimit,
    search = "",
    from = "",
    to = ""
  ) => {
    const params = new URLSearchParams({
      page: page || 1,
      pageLimit: pageLimit || 10,
    });

    if (search) params.append("search", search);
    if (from) params.append("from", from);
    if (to) params.append("to", to);

    return await APICall(
      `/api/AccountOfficer/admin/list-account-officers?${params.toString()}`,
      "GET"
    );
  };

  static exportAccountOfficer = async (search = "", from = "", to = "") => {
    const params = new URLSearchParams({
      page: 1,
      pageSize: 1000,
    });

    if (search) params.append("search", search);
    if (from) params.append("from", from);
    if (to) params.append("to", to);

    return await APICall(
      `/api/AccountOfficer/admin/export-account-officers?${params.toString()}`,
      "GET"
    );
  };

  static viewAccountOfficer = async (misCode) => {
    return await APICall(
      `/api/AccountOfficer/admin/view-account-officer?misCode=${misCode}`,
      "GET"
    );
  };

  static addAccountOfficer = async (payload) => {
    return await APICall(
      "/api/AccountOfficer/admin/add-account-officer",
      "POST",
      payload
    );
  };

  static editAccountOfficer = async (payload) => {
    return await APICall(
      "/api/AccountOfficer/admin/edit-account-officer",
      "POST",
      payload
    );
  };

  static deleteOfficer = async (payload) => {
    return await APICall(
      `/api/AccountOfficer/admin/delete-account-officer`,
      "DELETE",
      payload
    );
  };
}
